import axios from 'axios'
import { ElMessage } from 'element-plus'
import store from '@/store'
import { getToken } from '@/utils/auth'

// 创建axios实例
const service = axios.create({
  // baseURL: 'http://localhost:3000', // 不要在末尾添加斜杠，避免双斜杠问题
  baseURL: '', // 不要在末尾添加斜杠，避免双斜杠问题
  timeout: 15000 // 请求超时时间增加到15秒
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 添加token
    if (store.getters.token) {
      config.headers['Authorization'] = `Bearer ${getToken()}`
    }
    
    // 确保正确处理URL和斜杠
    if (config.url && typeof config.url === 'string') {
      // 移除URL末尾的斜杠，导致405错误
      if (config.url.endsWith('/') && config.url !== '/') {
        config.url = config.url.slice(0, -1)
        console.log('移除URL末尾斜杠:', config.url)
      }
      
      // 规范化URL，避免双斜杠问题
      const baseUrl = config.baseURL || '';
      const hasBaseSlash = baseUrl.endsWith('/');
      const hasUrlSlash = config.url.startsWith('/');
      
      if (hasBaseSlash && hasUrlSlash) {
        // 如果baseURL和url都有斜杠，移除url开头的斜杠
        config.url = config.url.substring(1);
      } else if (!hasBaseSlash && !hasUrlSlash && config.url !== '') {
        // 如果baseURL和url都没有斜杠，添加斜杠
        config.url = '/' + config.url;
      }
    }
    
    // 记录请求信息，帮助调试
    console.log(`发起${config.method.toUpperCase()}请求:`, 
                `${config.baseURL || ''}${config.url}`, 
                config.params || config.data || {})
    
    return config
  },
  error => {
    console.error('请求配置错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const { data, status } = response

    // 如果是文件下载等二进制数据，直接返回
    if (response.config.responseType === 'blob') {
      return response
    }

    // 直接返回响应数据，让调用者处理
    return data
  },
  error => {
    const { response } = error

    // 处理网络错误
    if (!response) {
      ElMessage({
        message: '网络错误，请检查您的网络连接',
        type: 'error',
        duration: 5000
      })
      return Promise.reject(error)
    }

    const { status, data } = response

    // 处理特定状态码
    switch (status) {
      case 401:
        ElMessage({
          message: '登录已过期，请重新登录',
          type: 'warning',
          duration: 5000
        })
        // 清除token并跳转到登录页
        store.dispatch('user/resetToken').then(() => {
          // 不再使用刷新页面，而是直接跳转到登录页
          location.href = '/#/login'
        })
        break
      case 403:
        ElMessage({
          message: '没有权限访问该资源',
          type: 'error',
          duration: 5000
        })
        break
      case 404:
        ElMessage({
          message: '请求的资源不存在',
          type: 'error',
          duration: 5000
        })
        break
      case 405:
        ElMessage({
          message: '请求方法不允许',
          type: 'error',
          duration: 5000
        })
        break
      case 500:
        ElMessage({
          message: '服务器错误，请稍后重试',
          type: 'error',
          duration: 5000
        })
        break
      default:
        ElMessage({
          message: data?.message || '请求失败',
          type: 'error',
          duration: 5000
        })
    }

    return Promise.reject(error)
  }
)

export default service